import TimeRangePicker from './TimeRangePicker';

export type { TimeRangePickerProps } from './TimeRangePicker';
export default TimeRangePicker;
